import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=a9dda5a2&scoped=true"
import script from "./LegalInformation.vue?vue&type=script&lang=js"
export * from "./LegalInformation.vue?vue&type=script&lang=js"
import style0 from "./LegalInformation.vue?vue&type=style&index=0&id=a9dda5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dda5a2",
  null
  
)

export default component.exports